// chartjs-plugin-crosshair (annoyingly) registers itself globally for all chartjs charts
// best to import here once; explicitly disable in all charts that do not need it
// (unregistering the plugin from Chartjs global plugins did not work)
import 'chartjs-plugin-crosshair'

export default defineNuxtPlugin(() => {})
